import { TranslateService } from '@ngx-translate/core';
import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'dgx-profile-heading',
  templateUrl: './profile-heading.component.html',
})
export class ProfileHeadingComponent {
  @Input() public heading: string;
  @Input() public viewAllUrl: string;
  @Input() public viewAllUrlQueryParams: Params;
  @Input() public showViewAll: boolean = true;
  @Input() public hasItems: boolean;
  @Input() public ownerIsViewing: boolean;
  @Input() public isMobile: boolean = false;

  public i18n = this.translateService.instant([
    'dgProfileOverview_ViewAllExperiences',
    'dgProfileOverview_ViewAllAchievements',
    'dgProfileOverview_ViewAllLearning',
  ]);

  constructor(private translateService: TranslateService) {}

  public get viewAllAriaLabel() {
    return this.i18n[`dgProfileOverview_ViewAll${this.heading}`];
  }
}
